import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ITableColumn, PipeObj, PipeResult } from './tabela.model';
import { IOpcaoAcao } from '../../utils/permissionScreen/permissionScreen.types';
import { Router } from '@angular/router';
import { ITela } from '../../utils/currentScreen/currentScreen.types';
import { validarTelaAtual } from '../../utils/currentScreen/currentScreen';
import { validarPermissao } from '../../utils/permissionScreen/permissionScreen';
import { sortSelectOptions } from '../../utils/sort-select-options';

@Component({
  selector: 'app-tabela',
  templateUrl: './tabela.component.html',
  styleUrls: ['./tabela.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TabelaComponent),
      multi: true
    }
  ]
})
export class TabelaComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() columns: ITableColumn[] = [];
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  selectedItem: any;
  selectedRowIndex: number | null = null;

  onSelectChange(value: any, item: any) {
    const body = {
      value: value,
      item: item
    };
    this.ngModelChange.emit(body);
  }

  sortedColumnOptions(options: { label?: string; name?: string; value: any }[] | undefined) {
    return sortSelectOptions(options ?? []);
  }

  toggleAtivo(item: any) {
    item.ativo = !item.ativo;
    this.selectedItem = item;
  }

  selectRow(index: number) {
    if (this.selectedRowIndex === index) {
      this.selectedRowIndex = null;
    } else {
      this.selectedRowIndex = index;
    }
  }

  viewIcon(acao: string): boolean {
    const acaoMap: Record<any, IOpcaoAcao> = {
      Visualizar: 'consultar',
      Ticket: 'imprimir',
      'Download Ticket': 'imprimir',
      'Impressao Ticket': 'imprimir',
      Editar: 'editar',
      Excluir: 'deletar',
      Delete: 'deletar',
      Suspender: 'suspender',
      Faturar: 'faturarCliente'
    };

    let telaAtual = this.router.url as ITela;

    if (acaoMap[acao]) {
      let telaAtualOpcaoTela = validarTelaAtual(telaAtual);

      if (telaAtualOpcaoTela)
        return validarPermissao(telaAtualOpcaoTela, acaoMap[acao]);
    }

    return true;
  }

  /** Em cadastro de saída o checkbox fica habilitado; na listagem exige permissão Suspender. */
  isCheckboxDisabled(): boolean {
    const url = (this.router.url || '').split('?')[0];
    if (url.includes('/cadastro/saida-gate')) {
      return false;
    }
    if (url.includes('/listagem/saida-gate')) {
      return !this.viewIcon('Suspender');
    }
    return false;
  }

  shouldShowCheckbox(column: ITableColumn, item: any): boolean {
    if (!column?.condition) {
      return true;
    }
    try {
      return !!column.condition(item);
    } catch {
      // Em cadastro de saída, falha na condição não pode esconder o checkbox.
      const url = (this.router.url || '').split('?')[0];
      return url.includes('/cadastro/saida-gate');
    }
  }

  /** @deprecated use isCheckboxDisabled */
  desabilitarCheckboxSaidaGate(): boolean {
    return !this.isCheckboxDisabled();
  }

  constructor(private router: Router) {}

  ngOnInit() {}

    applyPipe(column: ITableColumn, value: any): PipeResult {
    return column.pipe ? (column.pipe.transform(value) as PipeResult) : value;
  }

  isPipeObj(v: PipeResult): v is PipeObj {
    return typeof v === 'object' && v !== null && 'text' in v;
  }
}
